module.exports = __webpack_public_path__ + "img/i_kakao.1dc0fa63.svg";